/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiescolumnvenue2Inputs */

const en_opportunitiescolumnvenue2 = /** @type {(inputs: Opportunitiescolumnvenue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room`)
};

const de_opportunitiescolumnvenue2 = /** @type {(inputs: Opportunitiescolumnvenue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Room`)
};

/**
* | output |
* | --- |
* | "Live Room" |
*
* @param {Opportunitiescolumnvenue2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiescolumnvenue2 = /** @type {((inputs?: Opportunitiescolumnvenue2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiescolumnvenue2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiescolumnvenue2(inputs)
	return de_opportunitiescolumnvenue2(inputs)
});
export { opportunitiescolumnvenue2 as "opportunitiesColumnVenue" }